import Icon from 'veui/components/Icon'
import { IconEllipsisCircle } from 'dls-icons-vue'

Icon.register('ellipsis-circle', IconEllipsisCircle)
